import React from "react";
import { Box, Typography } from "@mui/material";
import img from "../assets/images/nodata.png";
const NoDataView = ({
  text = "No Data To Display",
  imageSrc,
  imageWidth = 150,
  imageHeight = 150,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        p: 2,
      }}
    >
      <Box
        component="img"
        src={img}
        alt="no-data"
        sx={{
          width: imageWidth,
          height: imageHeight,
          objectFit: "contain",
          mb: 2,
        }}
      />

      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: 500,
          color: "#6b7280",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default NoDataView;
